export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ImageWorker.worker.ed4acc2c72d5354fec1c.worker.js");
}
